// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./scripts/app.js");
__webpack_require__("./styles/app.css");
var __webpack_exports__ = __webpack_require__("../node_modules/@roots/bud-client/lib/hot/index.mjs?name=sage&indicator=true&overlay=true&reload=true");
